/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Sitesettings_Footer_Slogan1Inputs */

const vi_sitesettings_footer_slogan1 = /** @type {(inputs: Sitesettings_Footer_Slogan1Inputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Khẩu hiệu chân trang`)
};

/**

* @param {Sitesettings_Footer_Slogan1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const sitesettings_footer_slogan1 = /** @type {((inputs?: Sitesettings_Footer_Slogan1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Sitesettings_Footer_Slogan1Inputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_sitesettings_footer_slogan1(inputs)
});
export { sitesettings_footer_slogan1 as "siteSettings_footer_slogan" }